import {Injectable} from '@angular/core';
import {Profile} from '@models';
import {SubscriptionType} from '@enums';
import {SUBSCRIPTION_GALLERY_SLOTS} from '../../constants/subscription.constants';

export interface CurrentSubscriptionInfo {
	type: SubscriptionType;
	maxGallerySlots: number;
	expiresAt?: number;
	active: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class SubscriptionService {

	getMaxGallerySlots(profile: Profile | undefined): number {
		if (!profile || profile.subscriptionType === undefined || profile.subscriptionType === null) {
			return SUBSCRIPTION_GALLERY_SLOTS[SubscriptionType.Classique];
		}
		return SUBSCRIPTION_GALLERY_SLOTS[profile.subscriptionType as SubscriptionType] ?? 0;
	}

	hasActiveSubscription(profile: Profile | undefined): boolean {
		if (!profile) {
			return false;
		}
		const type = profile.subscriptionType as SubscriptionType | undefined;
		if (type === undefined || type === null || type === SubscriptionType.Classique) {
			return false;
		}
		if (profile.subscriptionExpiresAt !== undefined && profile.subscriptionExpiresAt !== null) {
			return profile.subscriptionExpiresAt > Date.now();
		}
		return true;
	}

	getCurrentSubscription(profile: Profile | undefined): CurrentSubscriptionInfo {
		const type = (profile?.subscriptionType ?? SubscriptionType.Classique) as SubscriptionType;
		const maxGallerySlots = SUBSCRIPTION_GALLERY_SLOTS[type];
		const expiresAt = profile?.subscriptionExpiresAt;
		const active = this.hasActiveSubscription(profile);
		return { type, maxGallerySlots, expiresAt, active };
	}
}
